import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessResidentNotifications } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { residentNotificationsRoutes } from "./routes";

/** Resident-only notification-center routes, including a scoped not-found fallback. */
export const residentNotificationsRoute = [
  {
    path: residentNotificationsRoutes.list,
    lazy: async () => {
      const { ResidentNotificationsPage } = await import("./pages/ResidentNotificationsPage");

      return {
        element: (
          <RequireAuth permission={canAccessResidentNotifications}>
            <ResidentNotificationsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
